/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Vuex from "vuex";

import state from "./state";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";
import vesselTrackingHistory from "./modules/vesselTrackingHistory";
import notification from "./modules/notification";
import realtimeMonitoring from "./modules/realtimeMonitoring";

Vue.use(Vuex);
import moduleAuth from "./auth/moduleAuth.js";

export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    auth: moduleAuth,
    vesselHistory: vesselTrackingHistory,
    notification,
    realtimeMonitoring
  },
  strict: process.env.NODE_ENV !== "production"
});
